import { MOET_CONSTANTS } from 'moet-core';

import { isSubmitted } from '../pre-assessment/selectors';
import { APP_PATHS, FLOW_STEP_PATHS, PRE_ASSESSMENT_STEP_PATHS } from '@/constants';
import PreAssessmentOverview from '@/containers/PreAssessmentOverview';
import PreAssessmentWrongPrefillData from '@/containers/PreAssessmentWrongPrefillData';

import { ReviewBlock } from '@/flow/blocks/kyc/common/Review.block';

const { MANAGED_ONBOARDING_TYPES } = MOET_CONSTANTS;

export function fallbackTo(path) {
  return {
    stepNotFoundPath: path,
    selectors: {},
    neededCaps: {},
    steps: [],
  };
}

export function preAssessmentOverviewFlow() {
  return {
    stepNotFoundPath: PRE_ASSESSMENT_STEP_PATHS.OVERVIEW_STEP,
    selectors: { isSubmitted },
    neededCaps: {},
    steps: [
      {
        id: 'pre-assessment-overview',
        path: PRE_ASSESSMENT_STEP_PATHS.OVERVIEW_STEP,
        prerequisite: 'isSubmitted',
        Container: PreAssessmentOverview,
        back: false,
        next: false,
      },
    ],
  };
}

export function preAssessmentWrongPrefillFlow() {
  return {
    stepNotFoundPath: PRE_ASSESSMENT_STEP_PATHS.WRONG_PREFILL_DATA,
    neededCaps: {},
    steps: [
      {
        id: 'pre-assessment-wrong-prefill-data',
        path: PRE_ASSESSMENT_STEP_PATHS.WRONG_PREFILL_DATA,
        Container: PreAssessmentWrongPrefillData,
        back: false,
        next: false,
      },
    ],
  };
}

export function celebrationFlow({ isUnmanagedKyc, widgetType, isWidget }) {
  const isManagedFlow = MANAGED_ONBOARDING_TYPES.includes(widgetType);
  const reviewBlock = new ReviewBlock({ isManagedFlow, isUnmanagedKyc, isWidget });
  return {
    stepNotFoundPath: isUnmanagedKyc
      ? isWidget
        ? FLOW_STEP_PATHS.APPLICATION_REVIEW
        : APP_PATHS.WHATS_NEXT_PATH
      : APP_PATHS.APPLICATION_OVERVIEW_PATH,
    selectors: reviewBlock.getSelectors(),
    neededCaps: {},
    steps: reviewBlock.generateFlowConfig(),
  };
}
